import { ONLINE_USERS } from './actions';

export default (previousState=[], { type, payload }) => {
    if (type === ONLINE_USERS) {
        return payload.onlineUsers;
    }
    return previousState;
}